import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import AHero from '../Basic/AHero';
import Btn from '../Basic/Btn';
import Container from '../Basic/Container';
import Desc from './Desc';
import Login from './Login';
import Media from './Media';
import Title from './Title';
import Wrap from './Wrap';

const Inner = styled.div`
	padding: 5rem 0 0 0;
	text-align: center;
	background: none;

	${rmq('ml')} {
		background: ${props => props.theme.gr2};
	}
`;

export default ({ login }) => (
	<Wrap>
		{login && (
			<Login href="https://courses.ahmadawais.com/" target="_blank" rel="noopener noreferrer">
				LOGIN →
			</Login>
		)}

		<Container>
			<Inner>
				<Title>VSCode Power User</Title>
				<Desc>
					After 10 years with Sublime Text, I switched to VSCode — the new open source cross-platform editor
					everyone's talking about. I've spent over a 1,000 hours perfecting my setup to help you{' '}
					<AHero href="#module1">switch today</AHero>. Bring all your{' '}
					<AHero href="#module2">custom settings</AHero> and learn the{' '}
					<AHero href="#module3">power user workflows</AHero> for <AHero href="#module4">HTML/CSS</AHero>,
					GitHub/
					<AHero href="#module5">Git & Open Source</AHero>, supercharged{' '}
					<AHero href="#module6">Markdown</AHero>, and everything from{' '}
					<AHero href="#module7">JavaScript</AHero> to <AHero href="#module8">PHP</AHero>, Go, Python, C++,
					C#, ROR & 50+ Extensions.
					<br />→ I'm <AHero href="#module9">sharing it all</AHero> in five hours — 65 videos online course.
				</Desc>
				<Btn href="#signup">GET STARTED NOW ↓</Btn>
				<Media />
			</Inner>
		</Container>
	</Wrap>
);
